import { STEP_IDS, PATIENT_MATCH_SUB_STEP_IDS, IMPORT_SUB_STEP_IDS } from '../constants'

interface INavigation {
  step: number
  subStep: number
}

export interface IImportDataFlags {
  hasVitalsOrLabs: boolean
  hasAttachments: boolean
}

export const getPreviousNavigation = (
  currentStep: number,
  currentSubStep: number,
  FORCE_PT_SEARCH: number,
  alreadyHasPatient: boolean,
  importData?: IImportDataFlags
): INavigation | null => {
  const hasVitalsOrLabs = importData?.hasVitalsOrLabs ?? true
  if (currentStep === STEP_IDS.IMPORT) {
    if (currentSubStep === IMPORT_SUB_STEP_IDS.ATTACHMENTS) {
      return hasVitalsOrLabs
        ? { step: STEP_IDS.IMPORT, subStep: IMPORT_SUB_STEP_IDS.VITALS_LABS }
        : { step: STEP_IDS.PATIENT_MATCH, subStep: PATIENT_MATCH_SUB_STEP_IDS.PATIENT_CONFLICT }
    }
    if (currentSubStep === IMPORT_SUB_STEP_IDS.VITALS_LABS) {
      return { step: STEP_IDS.PATIENT_MATCH, subStep: PATIENT_MATCH_SUB_STEP_IDS.PATIENT_CONFLICT }
    }
  }
  if (FORCE_PT_SEARCH === 1 && !alreadyHasPatient) {
    if (currentStep === STEP_IDS.PATIENT_MATCH) {
      if (currentSubStep === PATIENT_MATCH_SUB_STEP_IDS.PATIENT_CONFLICT) {
        return { step: STEP_IDS.PATIENT_MATCH, subStep: PATIENT_MATCH_SUB_STEP_IDS.PATIENT_SEARCH_RESULTS }
      }
      if (currentSubStep === PATIENT_MATCH_SUB_STEP_IDS.PATIENT_SEARCH_RESULTS) {
        return { step: STEP_IDS.PATIENT_MATCH, subStep: PATIENT_MATCH_SUB_STEP_IDS.PATIENT_SEARCH_FORM }
      }
      if (currentSubStep === PATIENT_MATCH_SUB_STEP_IDS.PATIENT_SEARCH_FORM) {
        return { step: STEP_IDS.PULSARA_SEARCH, subStep: 1 }
      }
    }
  } else {
    if (currentStep === STEP_IDS.PATIENT_MATCH) {
      if (currentSubStep === PATIENT_MATCH_SUB_STEP_IDS.PATIENT_CONFLICT) {
        return { step: STEP_IDS.PULSARA_SEARCH, subStep: 1 }
      }
    }
  }

  return null
}

export const getNextNavigation = (
  currentStep: number,
  currentSubStep: number,
  importData?: IImportDataFlags
): INavigation | null => {
  const hasVitalsOrLabs = importData?.hasVitalsOrLabs ?? false
  const hasAttachments = importData?.hasAttachments ?? false

  if (currentStep === STEP_IDS.PATIENT_MATCH && currentSubStep === PATIENT_MATCH_SUB_STEP_IDS.PATIENT_CONFLICT) {
    if (hasVitalsOrLabs) return { step: STEP_IDS.IMPORT, subStep: IMPORT_SUB_STEP_IDS.VITALS_LABS }
    if (hasAttachments) return { step: STEP_IDS.IMPORT, subStep: IMPORT_SUB_STEP_IDS.ATTACHMENTS }
    return null
  }

  if (currentStep === STEP_IDS.IMPORT && currentSubStep === IMPORT_SUB_STEP_IDS.VITALS_LABS) {
    if (hasAttachments) return { step: currentStep, subStep: IMPORT_SUB_STEP_IDS.ATTACHMENTS }
    return null
  }

  return null
}

export const getBackButtonVisibility = (currentStep: number): boolean => {
  if (currentStep === STEP_IDS.PULSARA_SEARCH) {
    return false
  }
  return true
}

export const getNextButtonVisibility = (
  currentStep: number,
  currentSubStep: number,
  importData?: IImportDataFlags
): boolean => {
  const hasVitalsOrLabs = importData?.hasVitalsOrLabs ?? false
  const hasAttachments = importData?.hasAttachments ?? false

  if (currentStep === STEP_IDS.PATIENT_MATCH && currentSubStep === PATIENT_MATCH_SUB_STEP_IDS.PATIENT_CONFLICT) {
    return hasVitalsOrLabs || hasAttachments
  }
  if (currentStep === STEP_IDS.IMPORT && currentSubStep === IMPORT_SUB_STEP_IDS.VITALS_LABS) {
    return hasAttachments
  }
  return false
}

export const getImportButtonVisibility = (
  currentStep: number,
  currentSubStep: number,
  importData?: IImportDataFlags
): boolean => {
  const hasVitalsOrLabs = importData?.hasVitalsOrLabs ?? false
  const hasAttachments = importData?.hasAttachments ?? false

  if (currentStep === STEP_IDS.PATIENT_MATCH && currentSubStep === PATIENT_MATCH_SUB_STEP_IDS.PATIENT_CONFLICT) {
    return !hasVitalsOrLabs && !hasAttachments
  }

  if (currentStep === STEP_IDS.IMPORT && currentSubStep === IMPORT_SUB_STEP_IDS.VITALS_LABS) {
    return !hasAttachments
  }
  return currentStep === STEP_IDS.IMPORT && currentSubStep === IMPORT_SUB_STEP_IDS.ATTACHMENTS
}
